<template>
  <div
    v-if="selectedResources.length === 1"
    class="item-detail-holder"
  >
    <div class="detail-image">
      <v-img
        v-if="selectedResources[0].downloadUri"
        :src="selectedResources[0].downloadUri"
        :title="selectedResources[0].description"
      >
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
              indeterminate
              color="grey-lighten-4"
            />
          </div>
        </template>
      </v-img>
      <YouTube
        v-if="!selectedResources[0].downloadUri && selectedResources[0].videoUri"
        ref="youtube"
        :src="selectedResources[0].videoUri"
        :height="320"
        :width="480"
      />
    </div>
    <div class="data-download">
      <div
        v-if="selectedResources[0].downloadUri != null"
        class="download-button"
        title="Download Item"
        @click="downloadResources()"
      >
        <div class="download-text">
          DOWNLOAD
        </div>
        <div class="download">
          <img
            :src="require('@/assets/svg/SVG/download.svg')"
            alt="Download"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia/dist/pinia';
import YouTube from 'vue3-youtube';

export default {
  name: 'ItemDetail',
  components: { YouTube },
  props: ['label'],
  computed: {
    ...mapStores(useRMTStore),
    selectedResources () {
      return this.RMTStore.selectedResources;
    }
  },
  methods: {
    downloadResources () {
      this.RMTStore.downloadResourcesZip();
    }
  }
};
</script>

<style scoped>
.item-detail-holder {
  margin-top: 20px;
  margin: 10px;
}
.data-download {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.detail-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 35%;
  background-color: #fafafa;
  margin-bottom: 20px;
}
.download-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.download-text {
  margin-right: 4px;
  width: 100%;
  text-transform: Uppercase;
  font-size: .8em;
  font-weight: bold;
  letter-spacing: .05em;
}
.download {
  text-align: center;
  width: 17px;
  height: 17px;
}
.download img {
  width: 100%;
  height: 100%;
}
</style>
